import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import { validateGuid } from "../services/apiService";
import { Buffer } from "buffer";
import Button from "../components/Button";
import ButtonUpload from "../components/ButtonUpload";
import Container from "../components/Container";
import Content from "../components/Content";
import { Row, Card, Col } from "react-bootstrap";
import { getHeadersAPI } from "../api/ServicesConfiguration";

interface docsRecord {
  Description_NL?: string;
  DocumentCode?: string;
  fileName: string;
  binary?: string;
  isUploaded: boolean;
}

function Upload() {
  const navigate = useNavigate();
  const queryParameters = new URLSearchParams(window.location.search);
  const guid = queryParameters.get("guid");
  const docCode = queryParameters.get("documentCode");
  const owner = queryParameters.get("owner");
  const [docDescription, setDocDescription] = useState("Document");
  const [files, setFiles] = useState<docsRecord[]>();
  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);

  const emptyFile: docsRecord = {
    fileName: "",
    isUploaded: false,
  };

  const fetchData = async () => {
    if (!(await validateGuid(guid!))) {
      navigate("/ErrorPage");
    }

    try {
      const response = await axios.get(process.env.REACT_APP_BASE_API_URL +"/getDocuments/" + guid + "/" + docCode,
        {
          headers: await getHeadersAPI()
        }
      );

      if (!response.data) {
        navigate("/ThankYouPage");
      }

      setFiles([]);

      if (response.data.length > 0) {
        setDocDescription(response.data[0].Description_NL);
        for (let i = 0; i < response.data[0].MaxPages; i++) {
          setFiles((previousState) => [...(previousState ?? []), emptyFile]);
        }
      } else {
        navigate(-1);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  //Run 1 time
  useEffect(() => {
    if (!guid) {
      navigate("/ErrorPage");
    } else {
      fetchData();
    }
  }, []);

  async function submitOnClick() {
    setIsLoading(true);


    let submitRecord = {
      guid: guid!,
      documentCode: docCode,
      files: files,
    };

    if (checkAllfilesUploaded(files)) {
      axios.post(
        process.env.REACT_APP_BASE_API_URL + "/submitDoc"
        , submitRecord
        , {
          headers: await getHeadersAPI()
        })
        .then((response) => {
          navigate("/UploadPortal?guid=" + guid + (owner === null ? null : "&owner=" + owner));
          setHasError(false);
        })
        .catch((error) => {
          console.error("API Error:", error);
          setIsLoading(false);
        });

    } else {
      setIsLoading(false);
      setHasError(true);
      // toast.error("Please upload documents");
    }
  }

  function checkAllfilesUploaded(files: any) {
    let allUploaded = true;
    // if (docCode === "04" || docCode === "05" || docCode === "08" || docCode === "10" || docCode === "100" || docCode === "530") {
    if (docCode === "04" || docCode === "05" || docCode === "08" || docCode === "10" || docCode === "100") {
    files.map((f: any) => {
        if (f.isUploaded === false) {
          allUploaded = false;
        }
      });
    } else {
      if (!(files.filter((doc: any) => doc.isUploaded).length > 0)) {
        allUploaded = false;
      }
    }

    if (allUploaded) {
      return true;
    } else {
      return false;
    }
  }

  function handleOnClickButtonUpload(index: any, file: any, binaryData: any) {
    setFiles((prevState) => {
      const newState = prevState?.map((obj, i) => {
        if (i === index) {
          return {
            ...obj,
            isUploaded: true,
            fileName: file.name,
            binary: Buffer.from(binaryData).toString("base64"),
          };
        }
        return obj;
      });
      return newState;
    });

    const result = files?.filter((f) => f.isUploaded === false);
  }

  function removeHandleOnClickButtonUpload(index: any) {
    setFiles((prevState) => {
      const newState = prevState?.map((obj, i) => {
        if (i === index) {
          return { ...obj, isUploaded: false, fileName: "", binary: "" };
        }
        return obj;
      });
      return newState;
    });

    const result = files?.filter((f) => f.isUploaded === false);
  }

  function backOnClick() {
    navigate("/UploadPortal?guid=" + guid + (owner === null ? null : "&owner=" + owner));
  }

  const overLayer = (
    <div className="over-layer">
      <div>Loading...</div>
    </div>
  );

  return (
    <div>
      <Content className="mt-5">
        <Container>
          <Card className="p-5">
            <Row>
              <div className="col-lg-5 upload-card-header mb-4">
                Upload {docDescription}
              </div>
              <CardDocumentDescriptiond docCode={docCode} />
              <div className="col-lg-12 mb-3" style={{ fontSize: 16, fontWeight: 700 }}>
                Uploaden
              </div>
              <Row className="ml-3 mb-5">
                {files?.map((f, i) => (
                  <ButtonUpload 
                    key={i} 
                    handleFile={(file: File, binaryData: ArrayBuffer) => {
                      handleOnClickButtonUpload(i, file, binaryData);
                    }}
                    removeHandleFile={(file: File, binaryData: ArrayBuffer) => {
                      removeHandleOnClickButtonUpload(i);
                    }}
                    uploaded={f.isUploaded}
                    name={f.Description_NL}
                  />
                ))}
                {hasError && (
                  <div className="col-lg-12 mt-3" style={{ color: "red", fontSize: 14, fontWeight: 700 }}>
                    Please upload documents
                  </div>
                )}
              </Row>
              <div className="col-lg-12 ">
                <Button className="btn btn-back" onClick={backOnClick} isLoading={isLoading}>
                  Vorige
                </Button>
                <Button className="btn-main-color float-right" onClick={submitOnClick} isLoading={isLoading}>
                  Bevestigen
                </Button>
              </div>
            </Row>
          </Card>
        </Container>
      </Content>
      {isLoading ? overLayer : ""}
    </div>
  );
}

function CardDocumentDescriptiond(docCode: any) {
  switch (docCode.docCode) {
    case "110": 
    case "120": 
    case "130":
      return <Salary />;
    case "190":
      return <BankStatement />;
    case "320":
      return <Benefit />;
    case "04": 
    case "05": 
    case "100":
      return <IDCard />;
    case "06": 
    case "07": 
    case "09":
      return <Passport />;
    case "08":
      return <ResidencePermit />;
    case "220":
      return <BankCard />;
    case "10":
      return <DrivingLicense />;
    case "370":
    case "180":
      return <TaxDeclaration/>;
    default:
      return <Default />;
  }
}

function Default() {
  return (
    <>
      <div className="col-lg-8">
        <div className="mb-2" style={{ fontSize: 16, fontWeight: 700 }}>
          {/* Instructies voor het uploaden */}
        </div>
        {/* <div className="mb-2"><i className="fas fa-check text-success mr-2" />Toegestaan als officieel legitimatiebewijs zijn: Europees paspoort, ID-kaart of een Nederlandse verblijfsvergunning.</div>
                <div className="mb-2"><i className="fas fa-check text-success mr-2" />Maak een foto/scan van uw orginele ID-bewijs.</div>
                <div className="mb-2"><i className="fas fa-check text-success mr-2" />Leg uw ID-bewijs op tafel en maak een foto van bovenaf. Voor een ID-kaart of verblijfsvergunning, fotogragrafeer of scan zowel de voor- als achterzijde los van elkaar.</div>
                <div className="mb-2"><i className="fas fa-times text-danger mr-2" />Een rijbewijs accepteren wij niet.</div>
                <div className="mb-2"><i className="fas fa-times text-danger mr-2" />Gebruik geen flits bij het maken van de foto</div>
                <div className="mb-2"><i className="fas fa-times text-danger mr-2" />Neem geen foto van een foto of van een kopie.</div> */}
      </div>
      <div className="col-lg-4"></div>
    </>
  );
}

function Salary() {
  return (
    <>
      <div className="col-lg-8">
        <div className="mb-2" style={{ fontSize: 16, fontWeight: 700 }}>
          Instructies voor het uploaden van uw loonstrook
        </div>
        <div className="mb-2">
          <i className="fas fa-check text-success mr-2" />
          Upload loonstrook van één <b>volledige maand</b> (neem dezelfde maand
          als bankaschrift).
        </div>
        <div className="mb-2">
          <i className="fas fa-check text-success mr-2" />
          Loonstrook <b>niet ouder</b> dan 2 maanden.
        </div>
        <div className="mb-2">
          <i className="fas fa-check text-success mr-2" />
          <b>Weekbetaling?</b> Upload 12 opeenvolgende wekelijkse loonstroken
        </div>
        <div className="mb-2">
          <i className="fas fa-check text-success mr-2" />
          <b>13emaand en/of vaste bonus ?</b> Reserving moet zichbaar zijn.
        </div>
        <div className="mb-2">
          <i className="fas fa-check text-success mr-2" />
          <b>Onregelmatigheidstoeslag en/of structurele overuren ?</b> Upload 3
          opeenvolgende maandelijkse loonstroken (12 opeenvolgende wekelijkse
          bij weekbetaling) waaruit dat blijkt.
        </div>
      </div>
      <div className="col-lg-4">
        <div className="float-right">
          <div style={{ textAlign: "center" }}></div>
          <img
            src="../../dist/img/salaryslip.jpg"
            alt="AdminLTE Logo"
            className="brand-image"
            style={{ opacity: ".8", width: 285 }}
          />
        </div>
      </div>
    </>
  );
}

function BankStatement() {
  return (
    <>
      <div className="col-lg-8">
        <div className="mb-2" style={{ fontSize: 16, fontWeight: 700 }}>
          Instructies voor het uploaden van uw bankafschrift
        </div>
        <div className="mb-2">
          <i className="fas fa-check text-success mr-2" />
          Upload bankafschrift van het prive-bankrekeningnummer dat u heeft
          ingevuld.
        </div>
        <div className="mb-2">
          <i className="fas fa-check text-success mr-2" />
          Bankafschrift moet van één volledige maand zijn (dezelfde maand als
          loonstrook).
        </div>
        <div className="mb-2">
          <i className="fas fa-check text-success mr-2" />
          Bankafschrift niet ouder dan 2 maanden.
        </div>
        <div className="mb-2">
          <i className="fas fa-check text-success mr-2" />
          Verwijder niets (ook weghalen of doorhalen mag niet): alles moet
          leesbaar zijn, ook uw persoonsgegevens en bankrekeningnummer.
        </div>
        <div className="mb-2">
          <i className="fas fa-check text-success mr-2" />
          Wordt uw huur/hypotheek afgeschreven van een andere bankrekening?
          Upload ook van deze bankrekening het volledige bankafschrift van
          dezelfde maand.
        </div>
      </div>
      <div className="col-lg-4">
        <div className="float-right">
          <div style={{ textAlign: "center" }}></div>
          <img
            src="../../dist/img/BankStatment.jpg"
            alt="AdminLTE Logo"
            className="brand-image"
            style={{ opacity: ".8", width: 285 }}
          />
        </div>
      </div>
    </>
  );
}

function Benefit() {
  return (
    <>
      <div className="col-lg-8">
        <div className="mb-2" style={{ fontSize: 16, fontWeight: 700 }}>
          Instructies voor het uploaden van uw uitkeringsspecificatie
        </div>
        <div className="mb-2">
          <i className="fas fa-check text-success mr-2" />
          Upload een foto, scan of digitale betalingsspecificatie (jpg of pdf)
          van uw pensioen of uitkering.
        </div>
        <div className="mb-2">
          <i className="fas fa-check text-success mr-2" />
          De betalingsspecificatie moet een volledige specificatie zijn van een
          hele maand.
        </div>
        <div className="mb-2">
          <i className="fas fa-check text-success mr-2" />
          De betalingsspecificatie mag maximaal 2 maanden oud zijn.
        </div>
        <div className="mb-2">
          <i className="fas fa-check text-success mr-2" />
          De betalingsspecificatie moet van dezelfde maand zijn als het door u
          geüploade bankafschrift.
        </div>
        <div className="mb-2">
          <i className="fas fa-check text-success mr-2" />
          Zorg ervoor dat alle informatie goed leesbaar is.
        </div>
      </div>
      <div className="col-lg-4">
        <div className="float-right">
          <div style={{ textAlign: "center" }}></div>
          <img
            src="../../dist/img/Image320NL.png"
            alt="AdminLTE Logo"
            className="brand-image"
            style={{ opacity: ".8", width: 285 }}
          />
        </div>
      </div>
    </>
  );
}

function IDCard() {
  return (
    <>
      <div className="col-lg-8">
        <div className="mb-2" style={{ fontSize: 16, fontWeight: 700 }}>
          Instructies voor het uploaden van uw legitimatiebewijs
        </div>
        <div className="mb-2">
          <i className="fas fa-check text-success mr-2" />
          Het legitimatiebewijs dient geldig te zijn
        </div>
        <div className="mb-2">
          <i className="fas fa-check text-success mr-2" />
          Upload de voor- en achterkant los van elkaar, dus NIET in 1 document.
          {/* Gebruikt u de KopieID app van de overheid? Maak een foto van de
          voorkant en sla deze op. Maak daarna een foto van de achterkant en sla
          deze apart op. Zo kunt u beide zijden separaat uploaden. */}
        </div>
        <div className="mb-2">
          <i className="fas fa-check text-success mr-2" />
          Uploadt u een foto of scan? Fotografeer of scan de voor – en
          achterkant los van elkaar en upload iedere zijde separaat.
        </div>
        <div className="mb-2">
          <i className="fas fa-check text-success mr-2" />
          Upload de foto’s/scans van uw legitimatiebewijs horizontaal (zie
          voorbeeld hiernaast).
        </div>
      </div>
      <div className="col-lg-4">
        <div className="float-right">
          <div style={{ textAlign: "center" }}>Voorzijde</div>
          <img
            src="../../dist/img/id-card-front.png"
            alt="AdminLTE Logo"
            className="brand-image"
            style={{ opacity: ".8", width: 285 }}
          />
          <div style={{ textAlign: "center" }}>Achterzijde</div>
          <img
            src="../../dist/img/id-card-back.png"
            alt="AdminLTE Logo"
            className="brand-image"
            style={{ opacity: ".8", width: 285 }}
          />
        </div>
      </div>
    </>
  );
}

function Passport() {
  return (
    <>
      <div className="col-lg-8">
        <div className="mb-2" style={{ fontSize: 16, fontWeight: 700 }}>
          Instructies voor het uploaden van uw paspoort
        </div>
        <div className="mb-2">
          <i className="fas fa-check text-success mr-2" />
          Uw paspoort moet geldig zijn.
        </div>
        <div className="mb-2">
          <i className="fas fa-check text-success mr-2" />
          Liever een foto? Fotografeer uw paspoort dan vanaf de bovenkant
          liggend op tafel en zorg dat het goed leesbaar is.
        </div>
        <div className="mb-2">
          <i className="fas fa-check text-success mr-2" />
          Upload de foto of scan horizontaal(zie voorbeeld).
        </div>

        <div className="mb-2">
          <i className="fas fa-check text-success mr-2" />
          Upload van het nieuwe passpoort ook de achterzijde, los van de voorzijde.
        </div>
        <div className="mb-2">
          <i className="fas fa-check text-success mr-2" />
          U mag de BSN aan de achterzijde afschermen maar het hoeft niet.
        </div>



      </div>
      <div className="col-lg-4">
        <div className="float-right">
          <div style={{ textAlign: "center" }}></div>
          <img
            src="../../dist/img/PassportBlacked.png"
            alt="AdminLTE Logo"
            className="brand-image"
            style={{ opacity: ".8", width: 285 }}
          />
        </div>
      </div>
    </>
  );
}

function ResidencePermit() {
  return (
    <>
      <div className="col-lg-8">
        <div className="mb-2" style={{ fontSize: 16, fontWeight: 700 }}>
          Instructies voor het uploaden van uw verblijfsvergunning
        </div>
        <div className="mb-2">
          <i className="fas fa-check text-success mr-2" />
          Upload de foto’s/scans van uw verblijfsvergunning horizontaal (zie
          voorbeeld hiernaast)
        </div>
        <div className="mb-2">
          <i className="fas fa-check text-success mr-2" />
          Zorg ervoor dat u de volledige verblijfsvergunning van zo dichtbij
          mogelijk fotografeert
        </div>
        <div className="mb-2">
          <i className="fas fa-check text-success mr-2" />
          Maak een duidelijke foto of scan van de voor- en achterzijde van uw
          verblijfsvergunning
        </div>
        <div className="mb-2">
          <i className="fas fa-check text-success mr-2" />
          Uw verblijfsvergunning moet geldig zijn
        </div>
        <div className="mb-2">
          <i className="fas fa-check text-success mr-2" />
          Er mogen geen hoeken buiten de foto/scan vallen
        </div>
        <div className="mb-2">
          <i className="fas fa-check text-success mr-2" />
          Let op dat alle informatie goed leesbaar is
        </div>
      </div>
      <div className="col-lg-4">
        <div className="float-right">
          <div style={{ textAlign: "center" }}></div>
          <img
            src="../../dist/img/residencepermitfront.jpg"
            alt="AdminLTE Logo"
            className="brand-image"
            style={{ opacity: ".8", width: 285 }}
          />
          <div style={{ textAlign: "center" }}></div>
          <img
            src="../../dist/img/residencepermitback.jpg"
            alt="AdminLTE Logo"
            className="brand-image"
            style={{ opacity: ".8", width: 285 }}
          />
        </div>
      </div>
    </>
  );
}

function BankCard() {
  return (
    <>
      <div className="col-lg-8">
        <div className="mb-2" style={{ fontSize: 16, fontWeight: 700 }}>
          Instructies voor het uploaden van uw bankpas
        </div>
        <div className="mb-2">
          <i className="fas fa-check text-success mr-2" />
          De bankpas moet van een zakelijke rekening zijn, van het bedrijf
          waarmee u de aanvraag heeft gedaan.
        </div>
        <div className="mb-2">
          <i className="fas fa-check text-success mr-2" />
          Een privé bankpas wordt niet geaccepteerd.
        </div>
        <div className="mb-2">
          <i className="fas fa-check text-success mr-2" />
          De tenaamstelling van de bankpas moet overeenkomen met de naam van het
          bedrijf.
        </div>
      </div>
      <div className="col-lg-4">
        <div className="float-right">
          <div style={{ textAlign: "center" }}></div>
          <img
            src="../../dist/img/BanckCardBlue.png"
            alt="AdminLTE Logo"
            className="brand-image"
            style={{ opacity: ".8", width: 285 }}
          />
          <div style={{ textAlign: "center" }}></div>
          <img
            src="../../dist/img/BankCardOrange.png"
            alt="AdminLTE Logo"
            className="brand-image"
            style={{ opacity: ".8", width: 285 }}
          />
        </div>
      </div>
    </>
  );
}

function DrivingLicense() {
  return (
    <>
      <div className="col-lg-8">
        <div className="mb-2" style={{ fontSize: 16, fontWeight: 700 }}>
          Instructies voor het uploaden van een Nederlands rijbewijs
        </div>
        <div className="mb-2">
          <i className="fas fa-check text-success mr-2" />U moet de Nederlandse
          nationaliteit hebben.{" "}
        </div>
        <div className="mb-2">
          <i className="fas fa-check text-success mr-2" />U kunt alleen een
          Nederlands rijbewijs uploaden.
        </div>
        <div className="mb-2">
          <i className="fas fa-check text-success mr-2" />
          Upload alleen de voorkant van het rijbewijs. De achterkant hebben we
          niet nodig.
        </div>
        <div className="mb-2">
          <i className="fas fa-check text-success mr-2" />
          Wilt u een foto maken? Fotografeer uw rijbewijs dan vanaf de bovenkant
          en zorg dat het volledig leesbaar is.
        </div>
        <div className="mb-2">
          <i className="fas fa-check text-success mr-2" />
          Gebruikt u de{" "}
          <a href="https://www.rijksoverheid.nl/onderwerpen/identiteitsfraude/vraag-en-antwoord/veilige-kopie-identiteitsbewijs">
            KopieID app
          </a>{" "}
          van de overheid? Uw BSN staat op de achterkant. Wij hebben alleen de
          voorkant nodig dus u hoeft niets weg te strepen.
        </div>
        <div className="mb-2">
          <i className="fas fa-check text-success mr-2" />
          Upload de foto of scan altijd horizontaal (zie voorbeeld hiernaast).
        </div>
      </div>
      <div className="col-lg-4">
        <div className="float-right">
          <div style={{ textAlign: "center" }}></div>
          <img
            src="../../dist/img/drivelicense.jpg"
            alt="AdminLTE Logo"
            className="brand-image"
            style={{ opacity: ".8", width: 285 }}
          />
        </div>
      </div>
    </>
  );
}

function TaxDeclaration() {
  return (
    <>
      <div className="col-lg-8">
        <div className="mb-2" style={{ fontSize: 16, fontWeight: 700 }}>
        Instructies voor het uploaden van uw aangifte Inkomstenbelasting
        </div>
        <div className="mb-2">
          <i className="fas fa-check text-success mr-2" />   Upload uw definitieve aangifte inkomstenbelasting (pdf of scan).
        </div>
        <div className="mb-2">
          <i className="fas fa-check text-success mr-2" />   Alleen de meest recente aangifte inkomstenbelasting
          (maximaal 20 mnd geleden ingediend) wordt geaccepteerd.
        </div>
        <div className="mb-2">
          <i className="fas fa-check text-success mr-2" />
          Zorg ervoor dat het een volledige aangifte inkomstenbelasting is.
        </div>
        <div className="mb-2">
          <i className="fas fa-check text-success mr-2" />
          Zorg ervoor dat alle informatie goed leesbaar is.
        </div>
        
      </div>
      <div className="col-lg-4">
        <div className="float-right">
          <div style={{ textAlign: "center" }}></div>
          <img
            src="../../dist/img/Image100NL.png"
            alt="AdminLTE Logo"
            className="brand-image"
            style={{ opacity: ".8", width: 285 }}
          />
        </div>
      </div>
    </>
  );
}

export default Upload;
